import {
  setOpenPreviewColorPicker,
  setPreviewColor,
} from '@storeOld/reducers/canvas/canvas'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

export const useColorPicker = () => {
  const dispatch = useDispatch()

  const [showColorPicker, setShowColorPicker] = useState<
    'add' | 'change' | null
  >(null)
  const [colorPickerArea, setColorPickerArea] = useState<HTMLDivElement | null>(
    null
  )
  const [colorByLongPress, setColorByLongPress] = useState<{
    hexCode: string
    colorId: string
  }>({ hexCode: '', colorId: '' })

  const onColorChangePreview = (hexCode?: string, id?: string) => {
    if (hexCode) {
      // @ts-expect-error
      dispatch(setPreviewColor(hexCode, id))
    } else {
      // @ts-expect-error
      dispatch(setPreviewColor(null))
    }
  }

  const handleShowColorPicker = (value: 'add' | 'change' | null) => {
    setShowColorPicker(value)
    dispatch(setOpenPreviewColorPicker(!!value))
  }

  return {
    showColorPicker,
    colorByLongPress,
    colorPickerArea,
    handleShowColorPicker,
    setColorPickerArea,
    setColorByLongPress,
    onColorChangePreview,
  }
}
